import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import MarqueeBands from '@/components/landing/marquee-bands'
import StudioSection from '@/components/landing/studio-section'
import WorkSection from '@/components/landing/work-section'
import ServicesSection from '@/components/landing/services-section'
import ProcessSection from '@/components/landing/process-section'
import TestimonialsSection from '@/components/landing/testimonials-section'
import ContactSection from '@/components/landing/contact-section'
import { siteConfig, SHARE_IMAGE_KEY } from '@/constants/site'

interface HomeProps {
    ogImage: string
}

const Home: FC<HomeProps> = ({ ogImage }): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={ogImage} />

            <HeroSection />
            <MarqueeBands />
            <StudioSection />
            <WorkSection />
            <ServicesSection />
            <ProcessSection />
            <TestimonialsSection />
            <ContactSection />
        </Layout>
    )
}

// The share image lives in storage. Building its address from the storage host at build
// time keeps social previews working on the live site even if that host ever changes.
export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const storageHost = (process.env.CDN_URL || '').trim().replace(/\/+$/, '')

    return {
        props: {
            ogImage: storageHost ? `${storageHost}/${SHARE_IMAGE_KEY}` : siteConfig.ogImage ?? ''
        }
    }
}

export default Home
